import axios from 'axios';
import {
  CREATE_COMPANY,
  EDIT_PROJECT,
  get_request_config
} from '@/utils/system_constants/constant.js';

export function normalize_project_id(value) {
  const project_id = Number(value);
  if (!Number.isInteger(project_id)) return null;
  return project_id > 0 ? project_id : null;
}

export function route_tenant_project_id(route = {}) {
  return normalize_project_id(route?.query?.project_id || route?.query?.tenant_id || '');
}

export async function ensure_tenant_project_types(component) {
  if (component.tenant_setup_project_types.length) {
    return true;
  }

  await component.load_tenant_setup_project_types();
  return true;
}

export function validate_tenant_project_fields(component) {
  if (!component.validate_tenant_setup_organisation()) {
    return null;
  }

  const project_type_id = component.tenant_setup_project_type_id();
  if (!project_type_id) {
    component.show_error('No project type is available for tenant setup.');
    return null;
  }

  return project_type_id;
}

export function build_tenant_project_payload(component, project_type_id) {
  const is_update = Boolean(component.tenant_setup_project_id);

  return {
    ...(is_update ? { project_id: component.tenant_setup_project_id } : {}),
    project_name: String(component.tenant_setup_form.organisation_name).trim(),
    project_description: component.tenant_setup_project_description(),
    project_type_id,
    enable_compliance_task: false
  };
}

export function tenant_project_endpoint(component) {
  return component.tenant_setup_project_id ? EDIT_PROJECT : CREATE_COMPANY;
}

export function saved_tenant_project_id(response_data = {}) {
  return normalize_project_id(response_data?.data?.project_id);
}

export async function save_tenant_project(component, project_type_id) {
  const response = await axios.post(
    tenant_project_endpoint(component),
    build_tenant_project_payload(component, project_type_id),
    get_request_config()
  );

  return component.parse_api_data(response.data);
}

export async function apply_saved_tenant_project(component, response_data = {}) {
  const project_id = saved_tenant_project_id(response_data);
  if (!project_id) {
    component.show_error(response_data.message || 'Tenant project could not be saved.');
    return false;
  }

  component.tenant_setup_project_id = project_id;
  await component.ensure_tenant_setup_contact();
  return true;
}
